import { environment } from '@env/environment';

export const SourceIdKey = environment?.SourceIdKey;
